import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var BuildingIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M21.88 20.87h-.41v-5.05h.41c.45 0 .85-.3.97-.74a.99.99 0 00-.47-1.12l-3.73-2.13V9.89c0-1.77-.69-3.44-1.95-4.7A6.59 6.59 0 0013 3.33v-1.2c0-.55-.45-1-1-1s-1 .45-1 1v1.2c-1.4.21-2.68.85-3.7 1.86a6.612 6.612 0 00-1.95 4.7v1.94l-3.73 2.13a.995.995 0 00.5 1.86h.41v5.05h-.41a1 1 0 00.01 2h19.75c.55 0 1-.45 1-1s-.45-1-1-1zm-2.41 0h-2.23v-5.05h2.23v5.05zM12 10.33l6.11 3.49H5.9l6.11-3.49H12zm-1 5.49v5.05H8.76v-5.05H11zm2 0h2.23v5.05H13v-5.05zM7.36 9.88c0-1.24.48-2.41 1.36-3.28.88-.88 2.04-1.36 3.28-1.36 1.24 0 2.41.48 3.28 1.36a4.64 4.64 0 011.36 3.28v.8l-4.15-2.37a.975.975 0 00-.99 0l-4.15 2.37v-.8h.01zm-2.82 5.94h2.23v5.05H4.54v-5.05z"
                    })
                })
            })
        ]
    });
};
BuildingIcon.isCarinaIcon = true;
export default BuildingIcon;
